export default __webpack_public_path__ + "static/media/landing-running-trial.054d3fa6.jpg";